import locationsModal from './locations-modal';
import { swapElementTag } from './dom-utils';

const CITY_TEXT_SWAP_DELAY_MS = 140;
const MOBILE_BREAKPOINT = 991;

const ensureElement = (value) => {
  if (!value) return null;
  if (typeof value === 'string') return document.getElementById(value);
  return value;
};

const getNode = (root, selector) => root?.querySelector(selector) || null;

export const recalcLocationCtaWidth = (ctaElementOrId) => {
  const ctaEl = ensureElement(ctaElementOrId);
  if (!ctaEl) return;

  const contentEl = getNode(ctaEl, '[data-location-cta-content]');
  if (!contentEl) return;

  // Mede largura natural via scrollWidth sem alterar o layout atual.
  const naturalContentWidth = Math.ceil(contentEl.scrollWidth || contentEl.getBoundingClientRect().width);
  const desiredWidth = naturalContentWidth + 20;
  const parentWidth = Math.ceil(ctaEl.parentElement?.getBoundingClientRect().width || desiredWidth);
  const isHeaderWeatherCta = ctaEl.id === 'current-weather-link';
  const isDisabledHeaderState = isHeaderWeatherCta && ctaEl.dataset.locationState === 'disabled';

  if (isDisabledHeaderState) {
    // Evita layout shift no reload com geolocalização bloqueada:
    // mantém largura natural sem aplicar width inline.
    ctaEl.style.width = '';
    return;
  }

  const finalWidth = isHeaderWeatherCta
    ? desiredWidth
    : Math.min(desiredWidth, parentWidth);
  ctaEl.style.width = `${finalWidth}px`;
};

export const transitionLocationCityText = (textElementOrId, nextText) => {
  const textEl = ensureElement(textElementOrId);
  if (!textEl || typeof nextText !== 'string') return;

  if (textEl.textContent === nextText) {
    return;
  }

  textEl.classList.add('is-hidden');

  window.setTimeout(() => {
    textEl.textContent = nextText;
    textEl.classList.remove('is-hidden');
    const cta = textEl.closest('.location-cta');
    if (cta) {
      recalcLocationCtaWidth(cta);
    }
  }, CITY_TEXT_SWAP_DELAY_MS);
};

export const setLocationIconState = (ctaElementOrId, state = 'disabled') => {
  const ctaEl = ensureElement(ctaElementOrId);
  if (!ctaEl) return;

  const iconEnabled = getNode(ctaEl, '[data-location-icon="enabled"]');
  const iconDisabled = getNode(ctaEl, '[data-location-icon="disabled"]');
  const stack = getNode(ctaEl, '[data-location-icon-stack]');
  const isEnabled = state === 'enabled';
  const nextState = isEnabled ? 'enabled' : 'disabled';
  const applyState = () => {
    ctaEl.dataset.locationState = nextState;

    if (stack) {
      stack.setAttribute('aria-label', isEnabled ? 'Localização habilitada' : 'Localização desabilitada');
    }

    if (iconEnabled) {
      iconEnabled.setAttribute('aria-hidden', isEnabled ? 'false' : 'true');
    }

    if (iconDisabled) {
      iconDisabled.setAttribute('aria-hidden', isEnabled ? 'true' : 'false');
    }
  };

  // Primeira transição de disabled->enabled precisa de 2 frames para não "pular".
  const hadNoTransition = ctaEl.classList.contains('location-cta--no-transition');
  const wasDisabled = (ctaEl.dataset.locationState || 'disabled') === 'disabled';
  if (isEnabled && hadNoTransition && wasDisabled) {
    ctaEl.classList.remove('location-cta--no-transition');
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        applyState();
      });
    });
    return;
  }

  if (isEnabled && hadNoTransition) {
    ctaEl.classList.remove('location-cta--no-transition');
  }

  applyState();
};

export const setupLocationCtaTag = ({
  elementId,
  isEnabled,
  href,
  navigationDataId,
  actionDataId,
}) => {
  const current = document.getElementById(elementId);
  if (!current) return null;

  const tag = isEnabled ? 'a' : 'button';
  const cta = swapElementTag(current, tag);
  if (!cta) return null;

  if (isEnabled) {
    cta.setAttribute('role', 'link');
    if (href) cta.setAttribute('href', href);
    cta.dataset.id = navigationDataId;
    cta.onclick = null;
    return cta;
  }

  cta.setAttribute('type', 'button');
  cta.setAttribute('role', 'button');
  cta.removeAttribute('href');
  cta.dataset.id = actionDataId;
  cta.onclick = (event) => {
    event.preventDefault();
    locationsModal.open();
  };
  return cta;
};

export const scheduleMobileLocationCollapse = (ctaElementOrId, isEnabled = true) => {
  const ctaEl = ensureElement(ctaElementOrId);
  if (!ctaEl) return;

  const textEl = getNode(ctaEl, '[data-location-city-text]');
  ctaEl.classList.remove('is-mobile-collapsing');
  if (textEl) {
    textEl.classList.remove('is-mobile-collapsing');
  }

  if (!isEnabled || window.innerWidth > MOBILE_BREAKPOINT) {
    return;
  }
  ctaEl.classList.add('is-mobile-collapsing');
  if (textEl) {
    textEl.classList.add('is-mobile-collapsing');
  }
};
